var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModule
    ? _c("div", { staticClass: "d-flex quioscoRipe" }, [
        _c("div", { staticClass: "col-3 pl-0" }, [
          _c("div", { staticClass: "portada d-flex align-items-center" }, [
            _vm.preview.url
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.preview.url,
                      target: "_blank",
                      rel: "noopener",
                    },
                  },
                  [
                    !_vm.userSelect
                      ? _c("img-lr", { attrs: { image: _vm.preview.cover } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userSelect
                      ? _c("img", {
                          attrs: {
                            src: _vm.preview.cover.url,
                            alt: _vm.preview.cover.alt,
                            title: _vm.preview.cover.title,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.preview.url
              ? _c(
                  "div",
                  [
                    !_vm.userSelect
                      ? _c("img-lr", { attrs: { image: _vm.preview.cover } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userSelect
                      ? _c("img", {
                          attrs: {
                            src: _vm.preview.cover.url,
                            alt: _vm.preview.cover.alt,
                            title: _vm.preview.cover.title,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-grow-1 pl-3 flex-column d-flex" }, [
          _c("h3", [_vm._v("PORTADAS")]),
          _vm._v(" "),
          _vm.preview.url
            ? _c(
                "a",
                {
                  attrs: {
                    href: _vm.preview.url,
                    target: "_blank",
                    rel: "noopener",
                  },
                },
                [
                  _c("h2", {
                    domProps: { innerHTML: _vm._s(_vm.preview.title) },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.preview.url
            ? _c("h2", { domProps: { innerHTML: _vm._s(_vm.preview.title) } })
            : _vm._e(),
          _vm._v(" "),
          _c("p", {
            staticClass: "mb-auto",
            domProps: { innerHTML: _vm._s(_vm.preview.lead) },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "slidePortadas" },
            [
              _c(
                "vue-tiny-slider",
                {
                  staticClass: "cover-items",
                  attrs: {
                    "mouse-drag": true,
                    loop: true,
                    items: "7",
                    gutter: "10",
                    "controls-container": "#customize-controls",
                  },
                },
                _vm._l(_vm.covers, function (item, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("img-lr", {
                        attrs: { image: item.coverMini, index: index },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm._m(0),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "customize-tools" }, [
      _c(
        "ul",
        { staticClass: "controls", attrs: { id: "customize-controls" } },
        [
          _c("li", { staticClass: "prev" }, [
            _c("i", { staticClass: "icon-arrow-left" }),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "next" }, [
            _c("i", { staticClass: "icon-arrow-right" }),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }